/* Candle Set page (st- prefix). Buy Now follows the same flow as fx-festive-combo.js:
   /cart/add.js → openFlexyCheckout when FlexyPe is ready, else /checkout. */
(() => {
  const root = document.querySelector('[data-st]');
  if (!root) return;
  const reduce = matchMedia('(prefers-reduced-motion: reduce)').matches;
  const hasIO = 'IntersectionObserver' in window;
  const $ = (s) => root.querySelector(s);
  const $$ = (s) => [...root.querySelectorAll(s)];
  const smooth = reduce ? 'auto' : 'smooth';

  const toastEl = $('[data-st-toast]');
  function toast(msg) {
    toastEl.textContent = msg;
    toastEl.classList.add('is-on');
    clearTimeout(toast.t);
    toast.t = setTimeout(() => toastEl.classList.remove('is-on'), 3200);
  }

  /* ---------- Cart / Buy Now ---------- */
  async function fetchCart() {
    try {
      const res = await fetch('/cart.js', { headers: { Accept: 'application/json' }, credentials: 'same-origin' });
      return res.ok ? await res.json() : null;
    } catch {
      return null;
    }
  }
  async function addToCart(item) {
    const res = await fetch(window.routes?.cart_add_url || '/cart/add.js', {
      method: 'POST',
      headers: { Accept: 'application/json', 'Content-Type': 'application/json' },
      body: JSON.stringify({ items: [item] }),
    });
    if (!res.ok) {
      const err = await res.json().catch(() => ({}));
      throw new Error(err.description || err.message || 'Could not add to cart');
    }
    const data = await res.json();
    document.dispatchEvent(new CustomEvent('cart:updated'));
    return data;
  }
  async function goToCheckout(item, addResponse) {
    const cart = await fetchCart();
    const flexyItems = [{ variant_id: item.id, quantity: item.quantity }];
    const handoff = {
      flow: 'buynow',
      source: 'mukhlis-candle-set',
      items: flexyItems,
      cart,
      addResponse: addResponse || null,
      attributes: cart?.attributes || {},
      note: cart?.note || '',
      token: cart?.token || '',
      item_count: cart?.item_count ?? 1,
      total_price: cart?.total_price,
      currency: cart?.currency,
      createdAt: Date.now(),
    };
    window.MukhlisCheckoutHandoff = handoff;
    document.dispatchEvent(new CustomEvent('mukhlis:checkout-ready', { detail: handoff }));
    if (typeof window.openFlexyCheckout === 'function' && window.flexypeCheckoutActive === true) {
      window.openFlexyCheckout('buy_now_button', undefined, flexyItems, Promise.resolve(addResponse || cart || { items: flexyItems }));
      return;
    }
    location.href = '/checkout';
  }

  const buyBtns = $$('[data-st-buy]');
  let busy = false;
  function setLoading(on, active) {
    buyBtns.forEach((b) => {
      if (on) {
        b.dataset.was = b.disabled ? '1' : '';
        b.disabled = true;
      } else b.disabled = b.dataset.was === '1';
    });
    const label = active.querySelector('.st-btn__label');
    if (on) {
      label.dataset.label = label.textContent;
      label.textContent = 'Please wait…';
    } else if (label.dataset.label) label.textContent = label.dataset.label;
  }
  async function buy(btn) {
    if (busy) return;
    const form = btn.closest('form') || $('[data-st-form]');
    const item = { id: Number(form?.querySelector('[name="id"]')?.value || root.dataset.variantId || 0), quantity: 1 };
    if (!item.id) return toast('This product is unavailable right now.');
    busy = true;
    setLoading(true, btn);
    try {
      const added = await addToCart(item);
      // Add mode (section setting show_buy_now off): same events as fx-festive-combo.js, no checkout
      if (btn.hasAttribute('data-st-add')) {
        document.dispatchEvent(new CustomEvent('cart:confirm', { detail: { message: `${root.dataset.productTitle || 'Item'} added to cart.`, added } }));
        return;
      }
      await goToCheckout(item, added);
    } catch (err) {
      // Network failures never show the raw "Failed to fetch" / "Load failed"
      const offline = err instanceof TypeError || /failed to fetch|load failed|networkerror/i.test(err.message || '');
      toast(offline ? 'Network slow hai, dobara try karein' : err.message || 'Something went wrong. Please try again.');
    } finally {
      busy = false;
      setLoading(false, btn);
    }
  }
  buyBtns.forEach((b) =>
    b.addEventListener('click', (e) => {
      e.preventDefault();
      buy(b);
    })
  );

  /* ---------- Chips → bottom sheet (mobile) / inline panel (desktop) ---------- */
  const sheet = $('[data-st-sheet]');
  const panel = $('[data-st-panel]');
  const sheetTitle = $('[data-st-sheet-title]');
  const sheetBody = $('[data-st-sheet-body]');
  const desk = matchMedia('(min-width: 1024px)');
  let chip = null;
  let modal = false;

  function lock(on) {
    const sw = innerWidth - document.documentElement.clientWidth;
    document.documentElement.style.overflow = on ? 'hidden' : '';
    document.body.style.paddingRight = on && sw > 0 ? `${sw}px` : '';
  }
  function openSheet(btn) {
    const tpl = $(`template[data-st-ans="${btn.dataset.stChip}"]`);
    if (!tpl) return;
    if (chip && chip !== btn) chip.setAttribute('aria-expanded', 'false');
    chip = btn;
    btn.setAttribute('aria-expanded', 'true');
    sheetTitle.textContent = tpl.dataset.title;
    sheetBody.replaceChildren(tpl.content.cloneNode(true));
    modal = !desk.matches;
    if (modal) panel.setAttribute('aria-modal', 'true');
    else panel.removeAttribute('aria-modal');
    sheet.hidden = false;
    if (modal) lock(true);
    requestAnimationFrame(() => sheet.classList.add('is-open'));
    panel.focus({ preventScroll: !modal });
  }
  function closeSheet() {
    if (sheet.hidden) return;
    sheet.classList.remove('is-open');
    if (modal) lock(false);
    chip?.setAttribute('aria-expanded', 'false');
    setTimeout(() => (sheet.hidden = true), modal && !reduce ? 260 : 0);
    chip?.focus({ preventScroll: true });
  }
  $$('[data-st-chip]').forEach((b) =>
    b.addEventListener('click', () => (chip === b && !sheet.hidden ? closeSheet() : openSheet(b)))
  );
  $$('[data-st-close]').forEach((b) => b.addEventListener('click', closeSheet));
  sheet.addEventListener('keydown', (e) => {
    if (e.key === 'Escape') return closeSheet();
    if (e.key !== 'Tab' || !modal) return;
    const f = [...panel.querySelectorAll('button:not([disabled]), a[href]')];
    const first = f[0];
    const last = f[f.length - 1];
    if (e.shiftKey && (document.activeElement === first || document.activeElement === panel)) {
      e.preventDefault();
      last.focus();
    } else if (!e.shiftKey && document.activeElement === last) {
      e.preventDefault();
      first.focus();
    }
  });

  /* ---------- Gallery ---------- */
  const track = $('[data-st-track]');
  const slides = $$('[data-st-slide]');
  const dots = $$('[data-st-dot]');
  let active = 0;
  const go = (i) => {
    active = (i + slides.length) % slides.length;
    track.scrollTo({ left: slides[active].offsetLeft - track.offsetLeft, behavior: smooth });
  };
  dots.forEach((d, i) => d.addEventListener('click', () => go(i)));
  $('[data-st-prev]')?.addEventListener('click', () => go(active - 1));
  $('[data-st-next]')?.addEventListener('click', () => go(active + 1));

  /* ---------- Sticky bar: hidden only while the hero Buy Now is really visible (not under the fixed header) ---------- */
  const sticky = $('[data-st-sticky]');
  const heroBuy = $('#st-buy-hero') || $('[data-st-hero-cta]');
  let stickyTick = false;
  const updateSticky = () => {
    stickyTick = false;
    const headerH = document.querySelector('[data-header-group-spacer]')?.offsetHeight || 0;
    const r = heroBuy.getBoundingClientRect();
    const visible = r.bottom > headerH + 8 && r.top < innerHeight - 8;
    sticky.classList.toggle('is-on', !visible);
    sticky.setAttribute('aria-hidden', String(visible));
  };
  addEventListener('scroll', () => { if (!stickyTick) { stickyTick = true; requestAnimationFrame(updateSticky); } }, { passive: true });
  addEventListener('resize', updateSticky);
  updateSticky();

  if (!hasIO) return;

  /* ---------- Entrance: below-the-fold blocks fade up once ---------- */
  if (!reduce) {
    root.classList.add('st-js');
    const revealIO = new IntersectionObserver(
      (es) =>
        es.forEach((e) => {
          if (!e.isIntersecting) return;
          e.target.classList.add('is-in');
          revealIO.unobserve(e.target);
        }),
      { rootMargin: '0px 0px -10% 0px' }
    );
    $$('.st-rv').forEach((el) => revealIO.observe(el));
  }

  if (dots.length) {
    const slideIO = new IntersectionObserver(
      (es) =>
        es.forEach((e) => {
          if (!e.isIntersecting) return;
          active = slides.indexOf(e.target);
          dots.forEach((d, j) => d.setAttribute('aria-current', String(j === active)));
        }),
      { root: track, threshold: 0.6 }
    );
    slides.forEach((s) => slideIO.observe(s));
  }
})();
